import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { UsersComponent } from './users/users.component';
import { ResetPasswordComponent } from './login/reset-password/reset-password.component';
import { ReportsComponent } from './reports/reports.component';
import { ReportsGemini35Component } from './reports-gemini35/reports-gemini35.component';
import { AuthGuard } from './auth.guard';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { TeamMemoComponent } from './team-memo/team-memo.component';
import { SugawaraMemoComponent } from './sugawara-memo/sugawara-memo.component';
import { SettingsComponent } from './settings/settings.component';
import { PromptsComponent } from './prompts/prompts.component';
import { PromptsGemini35Component } from './prompts-gemini35/prompts-gemini35.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'users', component: UsersComponent },
      { path: 'prompts', component: PromptsComponent },
      { path: 'prompts-gemini35', component: PromptsGemini35Component },
      { path: 'reports', component: ReportsComponent },
      { path: 'reports-gemini35', component: ReportsGemini35Component },
      { path: 'notes/project', component: TeamMemoComponent },
      { path: 'notes/minutes', component: SugawaraMemoComponent },
      { path: 'settings', component: SettingsComponent },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' }
    ]
  },
  { path: '**', redirectTo: '/dashboard' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }